import { render, staticRenderFns } from "./ShopMarketing.vue?vue&type=template&id=001a219a&scoped=true"
import script from "./ShopMarketing.vue?vue&type=script&lang=js"
export * from "./ShopMarketing.vue?vue&type=script&lang=js"
import style0 from "./ShopMarketing.vue?vue&type=style&index=0&id=001a219a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001a219a",
  null
  
)

export default component.exports